{
    "TITLE" : "Aplicativo Remoto",
    
        "SHARED": {
            "INTERNET_OFFLINE": "Sua conexão com a internet parece estar offline.",
            "LANGUAGE": "Língua",
            "NO_FEATURE": "Sua licença não contém esse recurso. Entre em contato com seu administrador.",
            "FEATURE_UNAVAILABLE": "Sua licença não contém esse recurso.",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "Você não tem permissão para usar este recurso. Por favor, peça permissão ao Anfitrião."
        },
        "UPDATE_MODAL": {
            "TITLE": "Atualização disponível",
            "MESSAGE": "Nova versão disponível. Esta página será recarregada após a atualização.",
            "UPDATE": "Recarregar",
            "UPDATE_FAILED": "Atualização falhou"
        },
        "LOGIN" : {
        "SSO-BUTTON": "Entrar com SSO",
            "APP_NAME": "{{ appName }} Remote",
            "TITLE": "Login para aplicativo remoto",
            "ACCOUNT_PLACEHOLDER" : "Nome da conta",
            "ACCOUNT_REQUIRED" : "O nome da conta é obrigatório.",
            "ACCOUNT_SHORT" : "O nome da conta deve ter pelo menos dois caracteres.",
            "USERNAME_PLACEHOLDER" : "Nome de usuário",
            "USERNAME_REQUIRED" : "Username name is required.",
            "USERNAME_SHORT" : "O nome do usuário deve ter pelo menos dois caracteres.",
            "PASSWORD_PLACEHOLDER" : "Senha",
            "PASSWORD_REQUIRED" : "Senha requerida.",
            "PASSWORD_SHORT" : "A senha deve ter pelo menos 6 caracteres.",
            "REMEMBER_ACCOUNT_NAME": "Lembrar nome da conta",
            "VERIFICATION_CODE": "Código de verificação",
            "TWO_FACTOR_EMAIL_SENDED": "Enviámos um e-mail com um código de verificação.",
            "VERIFY_BUTTON": "VERIFICAR",
            "LOGIN_BUTTON" : "ENTRAR",
            "BACK_BUTTON" : "VOLTAR",
            "BEFORE_TERMS": "Ao clicar em Login, você concorda com nossos ",
            "TERMS": "Termos de Serviço",
            "CONJUNCTION": " e ",
            "PRIVACY": "Política de Privacidade",
            "AFTER_PRIVACY": ".",
            "GUEST_DELETED": "Você está desconectado.",
            "USER_DELETED": "Sua conta foi deletada. Entre em contato com seu administrador.",
            "USER_DISABLED": "Sua conta foi desativada. Entre em contato com seu administrador.",
            "LOGGED_IN_ANOTHER_SESSION": "Você está logado em outra sessão.",
            "LOGGED_OUT_UNKNOWN": "Algo deu errado.",
            "NO_INTERNET_ERROR": "Sem internet. Por favor, verifique sua conexão à internet.",
            "USERNAME_PASSWORD_ERROR" : "O nome da conta, nome de usuário ou senha estão incorretos.",
            "ACCOUNT_DISABLED": "Sua conta expirou. Entre em contato com {{ contactMail }}",
            "INVALID_VERIFICATION_CODE" : "Código de verificação em duas etapas inválido.",
            "UNKNOWN_ERROR" : "Ocorreu um erro ao iniciar sessão.",
            "SIMULTANE_LOGIN_ERROR": "Você está logado em outra sessão.",
            "USE_CHINA_SERVERS": "Estou logando da China",
            "CHINA_SERVERS_CAUTION": "Esta opção pode causar latência fora da China Continental.",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "Login Múltiplo",
                "MESSAGE": "Seu usuário já fez login em outro dispositivo. Se você continuar, o outro usuário será desconectado.",
                "CANCEL": "Cancelar",
                "PROCEED": "Continuar"
            }
        },
        "MAIN" : {
            "LICENSE_LEFT": "Você tem {{ days }} dias restantes na sua licença do {{ appName }} Remote.",
            "DEMO_LEFT": "Você tem {{ days }} dias restantes na avaliação do {{ appName }} Remote.",
            "LEFT_BAR": {
                "LOBBY": "Salão",
                "ROOMS": "Quartos",
                "MEETINGS": "Encontros",
                "FEEDBACK": "Comentários",
                "CONTACTS": "Usuários",
                "SESSIONS": "Sessões",
                "TICKETS": "Tickets",
                "PRECALL_TEST": "Teste Precall",
                "WHATS_NEW": "O que há de novo",
                "PROFILE": "Perfil",
                "HELP_CENTER": "Centro de ajuda",
                "LOGOUT": "Sair"
            },
            "CALL_MESSAGE": {
                "TITLE":"Recebendo chamada de <strong>{{ caller_name }}</strong>",
                "DENY": "Negar",
                "ACCEPT": "Aceitar"
            },
            "GET_EXPORT_MODAL": {
                "TITLE": "Obter Exportação de Sessão",
                "MESSAGE1": "Digite seu endereço de e-mail para receber o link de download da exportação da sessão após o término da sessão.",
                "MESSAGE2": "A exportação de sessão incluirá todas as <strong>mensagens de bate-papo</strong>, <strong>instantâneos</strong>, <strong>registros de videochamada</strong> e <strong>arquivos</strong> compartilhados na sessão.",
                "EXPORT_NAME_NOT_LOCKED": "Você pode renomear o arquivo de exportação inserindo um nome de arquivo personalizado.",
                "EXPORT_NAME_LOCKED": "Você poderá renomear o arquivo de exportação assim que o outro usuário concluir a exportação.",
                "EXPORT_NAME_RENAMED": "O arquivo de exportação é renomeado por este usuário:",
                "EXPORT_NAME_PLACEHOLDER": "Nome da exportação",
                "NOTE": "Nota: Você pode atualizar seu endereço de e-mail no menu do perfil.",
                "NOTE2": "Nota: Você pode atualizar seu endereço de e-mail através do seu administrador.",
                "OPEN_PROFILE": "Abrir Perfil",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Email obrigatório.",
                "EMAIL_INVALID": "Formato de email inválido.",
                "CLOSE": "Perto",
                "SEND": "Enviar",
                "EXPORT_SUCCEEDED": "A exportação da sessão será enviada após o término da sessão.",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "A exportação de sessão é enviada.",
                "EXPORT_FAILED": "Um erro ocorreu."
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Gerenciar acesso público",
                "MANAGE-PUBLIC-ACCESS-TEXT": "Você pode parar de compartilhar este fluxo de trabalho excluindo o acesso público.",
                "GENEATE-ACCESS-TEXT": "Você pode gerar um link público e um código QR para criar um acesso fácil para este fluxo de trabalho.",
                "ENABLE-PASSWORD": "Habilitar senha",
                "GENERATE-ACCESS": "Gerar",
                "LINK": "Link",
                "COPY": "Copiar",
                "QR-CODE": "Código QR",
                "DOWNLOAD": "Baixar",
                "SECURITY": "Segurança",
                "PASSWORD-PROTECTED": "Protegido por senha",
                "PUBLIC": "Público",
                "DELETE-ACCESS": "Excluir acesso público",
                "EASY-ACCESS-TITLE": "{{ shortName }} Acesso fácil ao fluxo de trabalho",
                "OPEN-WORKFLOW-NAME": "Você está prestes a abrir",
                "GUEST-EMAIL": "Email do convidado",
                "REQUIRED": "Este campo é obrigatório",
                "GUEST-PASSWORD": "Senha para convidados",
                "OPEN": "ABRIR",
                "OPEN-APP": "Sugerimos abrir este fluxo de trabalho em nosso aplicativo para uma melhor experiência.",
                "COPY-LINK-TEXT": "Copie o link para a área de transferência para abrir este fluxo de trabalho quando o aplicativo for iniciado.",
                "DOWNLOAD-APP": "BAIXAR APLICATIVO",
                "DOWNLOAD-SMARTGLASSES-APP": "BAIXAR APLICATIVO PARA ÓCULOS INTELIGENTES",
                "OR": "OU",
                "CONTINUE-WITH-BROWSER": "Continuar com o navegador",
                "PASSWORD-PROTECTED-TEXT": "Quando a senha está habilitada, os usuários que têm o link público ou o código QR só podem acessar este fluxo de trabalho ao inserir a senha.",
                "CREATE-PASSWORD": "Criar senha",
                "ENTER-EMAIL": "Digite seu email",
                "ENTER-WORKFLOW-PASSWORD": "Digite a senha do fluxo de trabalho",
                "DELETE-QR-TEXT": "Para alterar o tipo de segurança do Acesso fácil, você deve excluir o Acesso fácil e gerar novamente.",
                "LOADING-WORKFLOW": "Carregando fluxo de trabalho...",
                "UNABLE-TO-LOAD": "Não foi possível carregar o fluxo de trabalho",
                "RETRY": "Tentar novamente",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "Token ausente ou inválido",
                    "ID-MISSING": "ID do fluxo de trabalho ou URL base está ausente",
                    "WORKFLOW-NOT-PUBLISHED": "O fluxo de trabalho não está publicado",
                    "PUBLIC-ACCESS": "O acesso público já existe",
                    "NO-PUBLIC-ACCESS": "Sem acesso público"
                },
                "QR-INFORMATION": "Informações QR"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Fluxos de vídeo",
                "CREATE-VIDEO-FLOW": "Criar fluxo de vídeo",
                "CREATED-BY-AI": "Criado por IA",
                "VERSION": "Versão",
                "NO-VIDEO-FLOWS-FOUND": "Nenhum fluxo de vídeo encontrado",
                "CLEAR-ALL": "Limpar tudo",
                "CONFIRM-VIDEO": "Confirmar vídeo",
                "CONFIRM-VIDEO-TITLE": "Confirmar conversão de vídeo",
                "CONFIRM-VIDEO-MESSAGE": "Tem certeza de que deseja converter este fluxo de vídeo em fluxo de trabalho? Após a confirmação, você não poderá editar o vídeo.",
                "CONFIRM-VIDEO-BUTTON": "Confirmar e converter",
                "MAKE-WORKFLOW-SUCCESSFUL": "Convertido para fluxo de trabalho com sucesso",
                "MAKE-WORKFLOW-ERROR": "Falha ao converter para fluxo de trabalho",
                "UPLOAD-VIDEO-DESCRIPTION": "Envie seu vídeo para gerar automaticamente um guia de fluxo de trabalho passo a passo.",
                "VIDEO-DURATION-LIMIT": "A duração do vídeo não pode exceder 30 minutos.",
                "VIDEO-UPLOADED-SUCCESS": "Vídeo enviado com sucesso!",
                "SELECT-VIDEO": "Selecionar vídeo",
                "CHANGE-VIDEO": "Alterar vídeo",
                "CREATE-BUTTON": "Criar",
                "AI-PROCESSING": "Processamento de IA em andamento",
                "SPLITTING-VIDEO": "Dividindo vídeo em segmentos",
                "TRANSCRIBING-VIDEO": "Transcrevendo conteúdo do vídeo",
                "PROCESS-WARNING": "Este processo pode levar até 10 minutos. Por favor, não feche esta janela."
            },
            "NAVBAR" : {
                "PRECALL_TEST": "Teste Precall",
                "PRECALL_END_SESSION": "Por favor, termine a sessão antes do teste Precall.",
                "LOGOUT" : "Sair",
                "LANGUAGE" : "Língua",
                "LOGOUT_MODAL_TITLE": "Sair?",
                "LOGOUT_MODAL_MESSAGE": "Isso vai te desconectar.",
                "CAUTION": "Cuidado: isso o desconectará sem encerrar a sessão. As janelas pop-up e outras informações após a sessão podem ser perdidas (por exemplo, exportação de sessão)!",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "Você sairá da sessão e fará logout.",
                "LOGOUT_MODAL_NO": "Cancelar",
                "LOGOUT_MODAL_YES": "Sair",
                "LOGOUT_FAILED": "Ocorreu um erro durante o logout.",
                "HELP_CENTER": "Centro de ajuda",
                "PROFILE_TITLE": "Perfil",
                "PROFILE_NAME": "Nome",
                "PROFILE_EMAIL": "Email",
                "PROFILE_PASSWORD": "Senha",
                "PROFILE_CHANGE_LINK": "Mudar",
                "PROFILE_ADD_LINK": "Adicionar",
                "PROFILE_CLOSE": "Perto",
                "CHANGE_PASS_TITLE": "Mudar senha",
                "CHANGE_PASS_OLD_PASS": "Senha Antiga",
                "CHANGE_PASS_NEW_PASS": "Nova senha",
                "CHANGE_PASS_RPT_PASS": "Confirme a Senha",
                "CHANGE_PASS_REQUIRED": "Senha requerida.",
                "CHANGE_PASS_NOT_MATCH": "As senhas não coincidem.",
                "CHANGE_PASS_CLOSE_BTN": "Perto",
                "CHANGE_PASS_CHANGE_BTN": "Mudar senha",
                "CHANGE_PASS_SUCCESS": "Sua senha mudou.",
                "CHANGE_PASS_WRONG": "Sua senha está errada.",
                "CHANGE_PASS_FAILED": "Falha na mudança de senha.",
                "CHANGE_EMAIL_TITLE": "Mude o e-mail",
                "CHANGE_EMAIL_NEW_EMAIL": "Novo Email",
                "CHANGE_EMAIL_RPT_EMAIL": "Confirmar e-mail",
                "CHANGE_EMAIL_REQUIRED": "E-mail é obrigatório.",
                "CHANGE_EMAIL_NOT_VALID": "E-mail não é válido.",
                "CHANGE_EMAIL_NOT_MATCH": "Os endereços de e-mail não coincidem.",
                "CHANGE_EMAIL_CLOSE_BTN": "Fechar",
                "CHANGE_EMAIL_CHANGE_BTN": "Mude o e-mail",
                "CHANGE_EMAIL_SUCCESS": "Seu email mudou.",
                "CHANGE_EMAIL_FAILED": "A alteração do email falhou.",
                "FEEDBACK": "Feedback",
                "SUCCESS_MESSAGE": "Obrigado por enviar o formulário. Nossa equipe entrará em contato com você em breve.",
                "CLOSE": "Fechar",
                "CREATE_NEW_PASS": "Requisitos de senha",
                "UPPERCASE": "Maiúsculas",
                "LOWERCASE": "Minúsculas",
                "NUMBER": "Número",
                "SPECIAL": "Especial",
                "AT_LEAST_PASSWORD_LENGTH": "Pelo menos {{passwordlength}} caracteres",
                "OLD_PASSWORD": "Senha Antiga",
                "NOT_WHITESPACE": "Sua senha não deve conter caracteres de espaço",
                "DO_NOT_CREATE_SIMPLE": "Não crie senhas fracas como '123456'",
                "STATUS": {
                    "AVAILABLE": "Disponível",
                    "BUSY": "Ocupada",
                    "APPEAR_OFFLINE": "Aparecer off-line"
                }
            },
            "LOBBY" : {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "Chamadas em Andamento",
                    "ROOMS_TITLE": "Seus quartos",
                    "UPCOMING_MEETINGS_TITLE" : "Próximas reuniões",
                    "PREVIOUS_MEETINGS_TITLE" : "Reuniões Anteriores",
                    "SCHEDULE_MEETING": "Reunião cronograma",
                    "INSTANT_GUEST_ACCESS": "Acesso de convidado instantâneo",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "Você não tem permissão para fazer chamadas. Entre em contato com o administrador.",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "Você não tem permissão para criar um link de acesso de convidado. Entre em contato com o administrador.",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "Você não tem permissão para fazer chamadas ou criar um link de acesso de convidado. Entre em contato com o administrador.",
                    "LINK_UNAVAILABLE": "Link indisponível",
                    "JOIN" : "JUNTE-SE",
                    "CANCEL": "CANCELAR",
                    "REMOVE": "REMOVER",
                    "NO_ROOM": "Você não tem espaço.",
                    "NO_MEETING": "Você não tem nenhuma reunião.",
                    "NO_PREV_MEETING": "Você não tem nenhuma reunião.",
                    "NO_OTHER_USERS": "Nenhum outro usuário.",
                    "SHOW_MORE": "mostre mais {{count}}",
                    "SHOW_LESS": "mostre menos"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "Reunião cronograma",
                    "MEETING_TITLE": "Título*",
                    "MEETING_TITLE_REQUIRED": "Título obrigatório.",
                    "START_DATE": "Começar",
                    "END_DATE": "Fim",
                    "CLOSE": "Perto",
                    "SCHEDULE_SEND": "Agendar e enviar",
                    "SCHEDULE": "Cronograma",
                    "CANNOT_SCHEDULE": "Ocorreu um erro ao agendar a reunião.",
                    "CANNOT_CANCEL_MEETING": "Ocorreu um erro ao cancelar a reunião.",
                    "ENTER_USERS": "Insira os usuários",
                    "SEND_INVITATIONS": "Enviar convites",
                    "INVITATION_EMAIL_LANG": "Idioma do e-mail de convite",
                    "SHARE_AFTER": "O link da reunião também pode ser compartilhado após o agendamento."
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "Cancelar Reunião",
                    "REMOVE_TITLE": "Remover reunião",
                    "CANCEL_MESSAGE": "Tem certeza que deseja cancelar a reunião?",
                    "REMOVE_MESSAGE": "Tem certeza de que deseja remover a reunião?",
                    "CLOSE": "Perto",
                    "PROCEED": "Continuar"
                },
                "CONTACTS": {
                    "TITLE": "Usuários",
                    "NO_CONTACT": "A lista de usuários está vazia.",
                    "NO_PERMISSION": "Você não tem permissão para ver a lista de usuários e chamadas.",
                    "SELECT_MULTI": "Selecione Vários",
                    "CALL": "Ligar",
                    "ADMIN": "Admin",
                    "COADMIN": "Co-Admin",
                    "EXPERT": "Expert",
                    "SUBSCRIBER": "Subscriber",
                    "USER": "User",
                    "NAME": "Nome",
                    "USERNAME": "Nome do usuário",
                    "ROLE": "Função",
                    "NO_EXPERT": "Selecione pelo menos um especialista para fazer uma chamada.",
                    "NAME_USERNAME": "Todas as funções",
                    "ALL_ROLES": "Todas as funções"
                },
                "SESSIONS": {
                    "TITLE": "Sessões",
                    "DATE": "Criado em",
                    "DURATION": "Duração total",
                    "ROOM_NAME": "Sala",
                    "NO_SESSIONS": "A lista de sessões está vazia.",
                    "PARTICIPANTS": "Participantes",
                    "EXPORT": "Exportação",
                    "STATUS": "Status",
                    "ON_GOING": "Em andamento",
                    "ENDED": "Finalizado",
                    "FILES": "Arquivos",
                    "CHAT": "Bater papo",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "Selecione Vários",
                        "DOWNLOAD": "Baixar",
                        "DOWNLOAD_STARTED_SOON": "O download será iniciado em breve.",
                        "DOWNLOAD_FAILED": "Falha no Download.",
                        "NO_FILE_IS_ADDED": "Nenhum arquivo é adicionado ou colaborado nesta sessão.",
                        "SUCCESS_MESSAGE": "Os arquivos foram baixados com sucesso."
                    },
                    "ATTACHED_TICKET": "Bilhete Anexado",
                    "SESSION_DETAILS": "Detalhes da sessão",
                    "BACK": "Voltar",
                    "GET_SESSION_EXPORT": "Obter exportação de sessão",
                    "ATTACH_TO_TICKET": "Anexar ao Bilhete"
                },
                "TICKETS": {
                    "TITLE": "Ingressos",
                    "NEW_TICKET": "Novo Ingresso",
                    "ALL_ROOMS": "Todas as salas",
                    "ALL_STATUSES": "Todos os status",
                    "NO_TICKETS": "A lista de ingressos está vazia.",
                    "TICKET_TITLE": "Título",
                    "ROOM": "Sala",
                    "CREATED_BY": "Criado por",
                    "CREATED_ON": "Criado em",
                    "STATUS": "Status",
                    "STATUS_OPEN": "aberto",
                    "STATUS_IN_PROGRESS": "em andamento",
                    "STATUS_CLOSED": "fechado",
                    "CLOSE_PICK_TICKET": "PERTO",
                    "CREATE_NEW": "CRIE UM NOVO",
                    "ATTACH": "ANEXAR",
                    "CREATE_TICKET": "Criar Ingresso",
                    "TICKET_DETAILS": "Detalhes do bilhete",
                    "EDIT": "EDITAR",
                    "TICKET_TYPE": "Tipo de bilhete",
                    "ROOM2": "Quarto:",
                    "CREATED_BY2": "Criado por:",
                    "CREATED_ON2": "Criado em:",
                    "ROOM3": "Quarto",
                    "STATUS2": "Status",
                    "PRIORITY": "Prioridade",
                    "ASSIGNEE": "Cessionário",
                    "FOLLOW_UP": "Data de acompanhamento",
                    "TICKET_TITLE2": "Título",
                    "TITLE_REQUIRED": "Título obrigatório",
                    "DESCRIPTION": "Descrição",
                    "DESCRIPTION_REQUIRED": "Descrição necessária",
                    "RESOLUTION": "Resolução",
                    "ATTACHED_SESSIONS": "SESSÕES ANEXAS",
                    "NO_ATTACHED_SESSIONS": "A lista de sessões anexadas está vazia",
                    "SESSION_COUNT": "Contagem de sessão:",
                    "TOTAL_DURATION": "Duração total:",
                    "PARTICIPANTS2": "Participantes:",
                    "COUNT_SESSIONS": "{{count}} Sessões",
                    "DATE": "Data",
                    "ROOM_NAME": "Nome da sala",
                    "PARTICIPANTS": "Participantes",
                    "DURATION": "Duração",
                    "GUEST": "(Convidado)",
                    "CANCEL": "CANCELAR",
                    "CLOSE": "PERTO",
                    "SAVE": "SALVAR",
                    "CREATE": "CRIAR",
                    "CREATED_BETWEEN": "Criado entre",
                    "ALL_CREATORS": "Todos os criadores",
                    "SEND_VIA_EMAIL": "ENVIAR VIA EMAIL",
                    "DELETE_TICKET": "EXCLUIR BILHETE",
                    "DELETE_TICKET_MODAL": {
                        "TITLE": "Excluir bilhete?",
                        "MESSAGE": "Tem certeza de que deseja excluir o tíquete <strong> {{title}} </strong>",
                        "CANCEL": "CANCELAR",
                        "DELETE": "EXCLUIR"
                    },
                    "LOW": "Baixo",
                    "MEDIUM": "Médio",
                    "HIGH": "Alto",
                    "CHOOSE_TICKET": "Escolha o ingresso",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "Bilhete já anexado.",
                        "ERROR_OCCURED": "Ocorreu um erro.",
                        "PERMISSION_DENIED": "Permissão negada.",
                        "MISSING_PARAMETERS": "Faltam parâmetros",
                        "FILE_ALREADY_EXIST": "O arquivo já existe"
                    },
                    "FILES": "arquivos",
                    "UPLOAD_FILE": "SUBIR ARQUIVO"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "Carregando",
                        "CREATED_AT": "Criado em",
                        "SIZE": "Tamanho",
                        "STATUS": "Status",
                        "DOWNLOAD": "Baixar",
                        "AVAILABLE": "Disponível",
                        "DISCONNECTED": "desconectado",
                        "DELETED": "apagada",
                        "EXPIRED": "expirado",
                        "WAITING": "espera",
                        "FAILED": "fracassada",
                        "REFRESH": "Atualizar",
                        "NO_ARCHIVE_MESSAGE": "Não há registro de videochamada",
                        "NAME": "Nome",
                        "STORAGE": "Armazenar",
                        "DURATION": "Duração",
                        "ARCHIVES": "Registros de videochamadas",
                        "PLAY": "Jogar",
                        "DELETE": "Excluir",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "Baixar registro",
                            "GENERATING": "Gerando URL de download",
                            "GENERATED": "URL de download gerado",
                            "CANNOT_GENERATED": "Não é possível gerar o URL de download.",
                            "DOWNLOAD": "Download",
                            "CLOSE": "Fechar"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "Apagar registro",
                            "MESSAGE": "O registro da chamada de vídeo será excluído.",
                            "CAUTION": "CUIDADO: Este registro também será excluído do armazenamento do Azure.",
                            "CANCEL": "Cancelar",
                            "DELETE": "Excluir"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "Conversor",
                    "STP_ONLY": "Apenas os formatos de arquivo .stp e .step são suportados.",
                    "ERROR_UPLOAD": "Ocorreu um erro ao enviar o arquivo.",
                    "DRAG": "Arraste e solte seu arquivo aqui",
                    "OR": "ou",
                    "CHOOSE": "Escolher arquivo",
                    "CONVERT": "Converter",
                    "SUPPORTED": "Formatos de arquivo suportados:",
                    "BACK": "Voltar",
                    "DOWNLOAD": "Download",
                    "ERROR_LOAD": "Ocorreu um erro ao carregar o objeto."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "O que há de novo",
                    "NO_UNREAD_UPDATE": "Nenhuma atualização não lida"
                },
                "JOIN_MODAL": {
                    "JOIN" : "JUNTE-SE",
                    "CALL": "LIGAR",
                    "CANCEL": "CANCELAR",
                    "MIRROR_VIDEO": "Espelho de Vídeo",
                    "PREFERRED_RESOLUTION": "Resolução preferencial",
                    "RESOLUTION_NOTE": "Nota: Se o seu dispositivo não suportar a resolução que você solicitou, a próxima maior resolução será usada.",
                    "CAM_MIC_PERM_REQUIRED": "É necessária permissão da câmera e do microfone",
                    "CAM_MIC_PERM_DENIED": "Acesso à câmera ou microfone negado",
                    "CAM_MIC_CANT_ACCESS": "Não podemos acessar sua câmera ou microfone",
                    "JOIN_CAM_OFF": "Junte-se com a câmera desligada",
                    "JOIN_MIC_OFF": "Junte-se com o microfone desligado",
                    "JOIN_CAM_MIC_OFF": "Junte-se à câmera e ao microfone desligados",
                    "JOIN_NO_DEVICE": "Junte-se sem câmera e microfone",
                    "ALLOW_ACCESS": "Você precisa permitir o acesso à câmera e ao microfone nas configurações do navegador (depois de conceder acesso, você ainda pode desligar a câmera ou o microfone).",
                    "TRY_AGAIN": "Tente novamente/atualize a página e selecione 'Permitir' quando solicitado pelo seu navegador."
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "Nenhum dispositivo encontrado",
                    "JOIN_BODY": "Não há microfone e câmera conectados a este dispositivo. Outros usuários não poderão ouvir ou ver você por meio deste dispositivo. Você ainda quer participar?",
                    "CALL_BODY": "Não há microfone e câmera conectados a este dispositivo. Outros usuários não poderão ouvir ou ver você por meio deste dispositivo. Você ainda quer ligar?",
                    "CANCEL": "Cancelar",
                    "JOIN": "Junte-se de Qualquer Maneira",
                    "CALL": "Ligue de Qualquer Maneira"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "Processamento e segurança do formulário de aprovação de dados pessoais",
                    "REJECTION_BUTTON": "Rejeitar",
                    "AGREEMENT_BUTTON": "Aceita"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "Cancelar o contrato?",
                    "ERROR": "Ocorreu um erro.",
                    "STATEMENT": "Se você não aceitar o contrato, não poderá fazer o login no sistema.",
                    "CANCEL_BUTTON": "Cancelar",
                    "PROCEED_BUTTON": "Continuar"
                },
                "JOIN_UNKNOWN_ERROR" : "Ocorreu um erro ao entrar na sala.",
                "JOIN_CONCURRENT_ERROR" : "Você atingiu o limite de usuários simultâneos da sua conta. Por favor, entre em contato com seu administrador para mais detalhes.",
                "JOIN_EXPERT_CONCURRENT_ERROR" : "Você atingiu o limite de usuários simultâneos da sua conta. Por favor, entre em contato com seu administrador para mais detalhes.",
                "NO_TRAINING_LICENSE": "Há um problema com a licença da sua sala de treinamento. Entre em contato com seu administrador.",
                "TRAINING_LICENSE_EXPIRED": "A licença da sua sala de treinamento expirou. Entre em contato com seu administrador.",
                "ASK_TRAINING_HOST": "Ocorreu um erro ao entrar na sala de treinamento. Entre em contato com o Host.",
                "JOIN_CALL_IN_PROGRESS": "Há uma outra chamada na sua sala de reuniões pessoal.",
                "NOT_SUPPORTED_TITLE": "Navegador Incompatível",
                "NOT_SUPPORTED_MESSAGE": "Seu navegador não é compatível. Por favor, use o Google Chrome, Mozilla Firefox, Safari ou Microsoft Edge (versão 79 ou mais recente).",
                "NO_IOS_MESSAGE": "Seu navegador não é compatível. Por favor, use o aplicativo {{ appName }} Remote ou use o Safari.",
                "IOS_VERSION_MESSAGE": "Seu navegador não é compatível. Por favor, use o aplicativo {{ appName }} Remote.",
                "NOT_SUPPORTED_CLOSE": "Perto",
                "IDLE_MODAL_TITLE": "Erro",
                "IDLE_MODAL_MESSAGE": "Você não fez nenhuma transação por um longo tempo.",
                "IDLE_MODAL_COUNT": "Você será desconectado em {{count}} segundos.",
                "IDLE_MODAL_OK": "Estou de volta",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "Permitir gravação?",
                    "MESSAGE": "A reunião nesta sala será gravada. Você precisa permitir a gravação de vídeo para entrar nesta sala.",
                    "DENY": "Negar",
                    "ALLOW": "Permitir"
                }
            },
            "ROOM" : {
                "OT_ERROR_MODAL": {
                    "TITLE": "Erro",
                    "CLOSE": "Continue de Qualquer Maneira",
                    "REJOIN": "Voltar a Juntar-se",
                    "ENDCALL": "Fora",
                    "ERRORS": {
                        "INTERNET": "Não é possível conectar a sessão. Por favor, verifique sua conexão à internet.",
                        "TRY_AGAIN": "Ocorreu um erro ao conectar a sessão. Por favor, tente novamente mais tarde.",
                        "UNKNOWN": "Ocorreu um erro ao conectar a sessão.",
                        "PUBLISHER_FAILED": "Falha ao compartilhar seu fluxo de vídeo com outros participantes.",
                        "PUBLISHER_CAM_MIC_ACCESS": "Verifique se a câmera e o microfone estão funcionando e se as permissões de câmera/microfone são concedidas.",
                        "SUBSCRIBER_FAILED": "Falha ao conectar-se a um dos fluxos de vídeo dos participantes."
                    }
                },
                "SIDEBAR" : {
                    "CHAT_TITLE" : "Bate-papo",
                    "PARTICIPANTS_TITLE" : "Participantes",
                    "FILES_TITLE" : "Arquivos",
                    "SETTINGS_TITLE" : "Definições",
                    "SHOW_TICKET": "Show Ticket",
                    "ATTACH_TO_TICKET": "Anexar ao tíquete",
                    "ATTACH_SESSION_TO_TICKET": "Anexar sessão ao tíquete",
                    "OPEN_WORKFLOW": "Abrir fluxo de trabalho",
                    "CHAT" : {
                        "SEE_TRANSLATION": "Ver tradução",
                        "SEE_ORIGINAL": "Ver original",
                        "TRANSLATING": "Traduzindo",
                        "FILE_SHARE" : {
                            "DRAG_HERE" : "Arraste Arquivos Aqui",
                            "UPLOAD_TITLE": "Fazer upload de arquivos",
                            "IMAGE": "Imagem",
                            "PDF": "Pdf",
                            "3D_OBJECT": "Objeto 3D",
                            "OTHER": "De outros",
                            "MULTIPLE_OBJECTS": "Encontramos vários objetos em seus arquivos. Faça o upload de um objeto (com texturas, se existir) por vez.",
                            "LARGER_THAN": "Maior que {{ megabytes }} MB",
                            "FILETYPE_PROHIBITED": "Tipo de arquivo proibido",
                            "START_UPLOAD": "ENVIO",
                            "CANCEL_UPLOAD": "PARE",
                            "CLOSE_UPLOAD": "PERTO",
                            "CANCEL_MODAL_TITLE": "Parar uploads?",
                            "CANCEL_MODAL_MESSAGE": "Isso interromperá os uploads atuais.",
                            "CANCEL_MODAL_CLOSE": "Cancelar",
                            "CANCEL_MODAL_CANCEL": "Pare"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "Excluir arquivo?",
                            "MESSAGE": "Arquivo será deletado",
                            "CLOSE": "Perto",
                            "DELETE": "Excluir"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "Detalhes do arquivo",
                            "FILENAME": "Nome do arquivo",
                            "SIZE": "Tamanho",
                            "TYPE": "Tipo",
                            "UPLOAD_TIME": "Hora do upload",
                            "DOWNLOAD": "Baixar",
                            "CLOSE": "Perto",
                            "FILECOUNT": "Contagem total de arquivos"
                        },
                        "COLLABORATE": "Colaborar",
                        "CLOSE_COLLABORATION": "Fechar colaboração",
                        "DOWNLOAD": "Baixar",
                        "DELETE": "Excluir",
                        "DETAILS": "Detalhes",
                        "SEND_TO_FILES": "Enviar para Arquivos",
                        "FILE_DELETED": "Arquivo excluído",
                        "JOIN_ROOM" : "{{owner_info}} entrou na sala.",
                        "LEAVE_ROOM" : "{{owner_info}} saiu da sala.",
                        "REACTION": "{{ owner_info }} enviou uma reação.",
                        "REQUEST_SCREENSHOT": "{{owner_info}} instantâneo solicitado.",
                        "SHARE_SCREENSHOT" : "{{owner_info}} compartilhou um instantâneo.",
                        "SAVED_COLLABORATION": "Colaboração salva.",
                        "SHARE_IMAGE" : "{{owner_info}} compartilhou uma imagem.",
                        "SHARE_PDF" : "{{owner_info}} compartilhou um pdf.",
                        "SHARE_OTHER" : "{{owner_info}} compartilhou um arquivo.",
                        "SHARE_OBJECT" : "{{owner_info}} compartilhou um objeto 3D.",
                        "COLLABORATED" : "{{owner_info}} começou a colaboração.",
                        "TYPE_HERE" : "digite aqui...",
                        "PLEASE_WAIT_OTHERS": "Por favor, aguarde a participação de outros usuários.",
                        "DOWNLOAD_STARTED_SOON": "O download será iniciado em breve.",
                        "DOWNLOAD_FAILED": "Falha no Download.",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "Download de objeto ainda não suportado.",
                        "DOWNLOAD_NOT_SUPPORTED": "Download não suportado ainda.",
                        "CLOSE_PREV_COLLABORATION_TITLE": "Fechar a colaboração de arquivos atual?",
                        "CLOSE_COLLABORATION_TITLE": "Fechar a colaboração de arquivos?",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "Isso encerrará a colaboração de arquivos atual e iniciará uma nova.",
                        "CLOSE_COLLABORATION_MESSAGE": "Isso encerrará a colaboração de arquivos.",
                        "CLOSE_PREV_COLLABORATION_YES": "Prosseguir",
                        "CLOSE_PREV_COLLABORATION_NO": "Cancelar",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Abrir colaboração de arquivos?",
                            "MESSAGE_AUTHORIZED": "Existe uma janela fixada. Você deseja liberá-lo e abrir a colaboração de arquivos?",
                            "MESSAGE_UNAUTHORIZED": "O arquivo de colaboração não pode ser aberto porque existe uma janela fixada.",
                            "CANCEL": "Cancelar",
                            "CLOSE": "Perto",
                            "PROCEED": "Continuar"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "Fechar o ARPlus?",
                            "MESSAGE": "Você precisa fechar o AR+ antes de poder abrir a colaboração. Tem certeza de que deseja fechar o AR+?",
                            "NO": "Não",
                            "YES": "Sim"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "(Gerente)",
                        "LOWER_ALL_HANDS": "Baixar todas as mãos",
                        "RAISED_HAND": "{{ name }} levantou a mão.",
                        "DENIED_PUBLISH": "{{ name }} recusou participar da comunicação de vídeo/áudio.",
                        "PARTICIPANT_LIMIT_REACHED": "Limite de participante da comunicação de vídeo/áudio atingido.",
                        "CALLING": "Chamando: {{ participants }}"
                    },
                    "FILES": {
                        "INFO_TEXT": "Todos os especialistas e coadministradores que têm acesso a esta sala podem ver e modificar os arquivos nesta seção",
                        "DOWNLOAD": "Download",
                        "SEND_TO_SESSION": "Enviar para sessão",
                        "DELETE": "Excluir",
                        "UPLOAD_FILE": "Subir arquivo",
                        "FILE_CONTENTS": "Conteúdo do arquivo:",
                        "FILE_NAME": "Nome do arquivo:",
                        "FILE_SIZE": "Tamanho do arquivo:",
                        "TOTAL_SIZE": "Tamanho total:",
                        "DOWNLOAD_STARTED_SOON": "O download será iniciado em breve.",
                        "DOWNLOAD_FAILED": "Falha no Download.",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "Excluir arquivo?",
                            "MESSAGE_DELETE": "Tem certeza de que deseja excluir este arquivo?",
                            "CANCEL": "Cancelar",
                            "DELETE": "Excluir"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "Microfone",
                        "CAMERA": "Câmera",
                        "TRANSLATE_OTHERS_MSG_TO": "Traduzir Outras Mensagens Para:",
                        "TRANSLATE_MY_MSG_TO": "Traduzir Minhas Mensagens Para:",
                        "CREATE_GUEST_ACCESS": "Criar acesso de convidado",
                        "GENERATING": "Geradora",
                        "GUEST_ACCESS": "Acesso de convidado",
                        "COPY_LINK": "Cópia",
                        "LINK_COPIED": "Link copiado para a área de transferência.",
                        "LINK_GENERATED": "Link para participar da sessão gerado.",
                        "CANNOT_CREATE_GUEST_ACCESS": "Não é possível criar acesso de convidado.",
                        "NO_LINK_PERMISSION": "Você não tem permissão para criar link de acesso de convidado. Entre em contato com o seu administrador.",
                        "SHARE": "Compartilhar",
                        "SHARE_LINK_VIA_SMS": "Compartilhar link via SMS",
                        "SMS_SEND": "Link enviado via SMS",
                        "OPENING": "Abertura",
                        "SEND": "Enviar",
                        "SMS_LIMIT_REACHED": "Limite de envio de SMS atingido. Entre em contato com seu administrador.",
                        "ERROR_OCCURED": "Ocorreu um erro.",
                        "SMS_LICENSE_PERMISSION": "Você não tem permissão para enviar SMS. Entre em contato com seu administrador.",
                        "RESHARE": "Você pode compartilhar o link uma vez por minuto.",
                        "DIDNT_GET": "Não recebeu o link?",
                        "PHONE_NUMBERS": "Números de telefone usados recentemente",
                        "RESEND": "Reenviar.",
                        "CANCEL": "Cancelar",
                        "CONNECT_VIA_FIELD_CODE": "Conecte-se com o usuário via Field ID",
                        "CONNECT": "Conectar",
                        "INVITATION_SENT": "O convite foi enviado ao usuário.",
                        "INVITATION_COULD_NOT_SENT": "O convite não pôde ser enviado ao usuário.",
                        "FIELD_CODE": "Field ID"
                    }
                },
                "VIDEO_CHAT" : {
                    "AUDIO_BITRATE": "Taxa de bits do áudio",
                    "AUDIO_PACKET_LOSS": "Perda de pacote de áudio",
                    "VIDEO_BITRATE": "Taxa de bits do vídeo",
                    "VIDEO_PACKET_LOSS": "Perda de pacote de vídeo",
                    "RESOLUTION": "Resolução",
                    "WAIT_OTHER_USERS" : "Por favor, aguarde a participação de outros usuários.",
                    "WAIT_EXPERT": "Por favor, aguarde a participação do especialista.",
                    "WAIT_MASTER": "Por favor, Gerente o asasdsd iniciar a sessão.",
                    "START_SESSION": "INICIAR SESSÃO",
                    "HOST_WITHDRAW_REQUEST": "Gerente retiram o pedido de vídeo/áudio.",
                    "NO_CAM_MIC": "Sua câmera e microfone não estão disponíveis.",
                    "NO_CAM": "Sua câmera não está disponível.",
                    "NO_MIC": "Seu microfone não está disponível.",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "Aderir à comunicação de vídeo/áudio?",
                        "MESSAGE": "O Gerente deseja que você habilite seu vídeo/áudio.",
                        "DENY": "Negar",
                        "ACCEPT": "Aceitar"
                    },
                    "PUBLISHER" : {
                        "YOU": "Você",
                        "SCREEN_SHARE_MESSAGE": "Você está compartilhando sua tela",
                        "STOP_SCREEN_SHARING": "Pare de compartilhar"
                    },
                    "SUBSCRIBER" : {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "O status da rede não pode ser exibido porque o aplicativo deste participante não está atualizado.",
                        "SNAPSHOT": "Instantâneo",
                        "AR_PLUS": "AR Colaboração",
                        "SCREENSHOT_REQUESTED": "Instantâneo solicitado",
                        "VIDEO_NOT_AVAILABLE": "Vídeo não está disponível",
                        "WEAK_SIGNAL": "Sinal fraco",
                        "AUDIO_ONLY_MODE": "Modo somente áudio",
                        "FLASH": "Flash",
                        "AR_NOT_AVAILABLE": "AR não disponível para este dispositivo.",
                        "CHARGING": "A carregar",
                        "LOW_BATTERY": "Bateria Fraca",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "Fechar o ARPlus?",
                            "MESSAGE": "Tem certeza de que deseja fechar o ARPlus?",
                            "NO": "Não",
                            "YES": "Sim"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Abrir o AR+?",
                            "MESSAGE_AUTHORIZED": "Existe uma janela fixada. Deseja desafixar e abrir o AR+?",
                            "MESSAGE_UNAUTHORIZED": "O AR+ não pode ser aberto porque existe uma janela fixada.",
                            "CANCEL": "Cancelar",
                            "CLOSE": "Perto",
                            "PROCEED": "Continuar"
                        },
                        "REFRESH_SURFACES": "Atualizar superfícies",
                        "AR_PLUS_LOCKED": "AR+ está bloqueado. Por favor, desbloqueie o AR+ primeiro."
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "Compartilhar tela",
                        "STOP_SHARE": "Pare de compartilhar",
                        "MIC_OFF": "Microfone",
                        "CAM_OFF": "Câmera",
                        "CAM_MIC_CANT_ACCESS": "Não podemos acessar sua câmera ou microfone",
                        "LEAVE_CALL": "Sair",
                        "LEAVE_SESSION": "Sair da Sessão",
                        "LEAVE_MEETING": "Sair da reunião",
                        "END_SESSION_FOR_ALL": "Terminar Sessão para Todos",
                        "END_MEETING_FOR_ALL": "Terminar a reunião para todos",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "Sair da Sessão?",
                            "TITLE_LEAVE_MEETING": "Sair da reunião?",
                            "TITLE_END_ALL": "Terminar Sessão para Todos?",
                            "TITLE_END_ALL_MEETING": "Terminar a reunião para todos?",
                            "MESSAGE_LEAVE": "Tem certeza que deseja sair da sessão?",
                            "MESSAGE_END_ALL": "Tem certeza que deseja encerrar a sessão?",
                            "MESSAGE_LEAVE_MEETING": "Tem certeza de que deseja sair da reunião?",
                            "MESSAGE_END_ALL_MEETING": "Tem certeza de que deseja encerrar a reunião?",
                            "CANCEL": "Cancelar",
                            "END": "Fim",
                            "LEAVE": "Sair",
                            "REMOVE_MEETING_LINK": "Desative e remova também o link da reunião"
                        },
                        "RAISE_HAND": "Levante a mão",
                        "LOWER_HAND": "Mão Inferior",
                        "RECORD": "Registro",
                        "AUTO_RECORD": "Auto Registro",
                        "STOP_RECORD": "Parar Registro",
                        "CANCEL": "Cancelar pedido",
                        "ASK_ARCHIVE_PERMISSION": "Peça permissão de gravação",
                        "REACTION": "Reação",
                        "EXTENSION_MODAL_TITLE": "Extensão necessária",
                        "EXTENSION_MODAL_MESSAGE": "O Google Chrome requer extensão para o recurso Compartilhamento de tela. Por favor, instale a extensão ou use o Mozilla Firefox.",
                        "EXTENSION_MODAL_NO": "Cancelar",
                        "EXTENSION_MODAL_YES": "Abrir a página de extensão",
                        "ARCHIVE_NO_PERMISSION": "Você não tem permissão para gravar esta sessão. Entre em contato com seu administrador.",
                        "P2P_NO_ARCHIVE": "Registro indisponível para vídeo chamadas ponto a ponto. Entre em contato com seu administrador.",
                        "SCREEN_SHARE_UPDATE": "A versão atual do seu navegador não suporta compartilhamento de tela. Por favor, atualize seu navegador.",
                        "SCREEN_SHARE_NOT_SUPPORTED": "Seu navegador não suporta compartilhamento de tela.",
                        "SCREEN_SHARE_USE_OTHER": "Seu navegador não suporta compartilhamento de tela. Por favor, use o Google Chrome ou Mozilla Firefox.",
                        "SCREEN_SHARE_FAILED": "Não é possível compartilhar a tela.",
                        "ARCHIVE_REQUESTED": "A gravação de vídeo será iniciada. Sua permissão é necessária.",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }} quer começar a gravar o vídeo. Sua permissão é necessária.",
                        "DENY": "Negar",
                        "ALLOW": "Permitir"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "Página Anterior",
                        "NEXT_PAGE": "Próxima Página"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "Alguns usuários não podem carregar a colaboração de arquivos.",
                        "DOWNLOAD_FAILED": "Não é possível fazer download de colaboração de arquivo.",
                        "END_COLL_TITLE": "Fechar a colaboração de arquivos?",
                        "END_COLL_MESSAGE": "Isso encerrará a colaboração de arquivos.",
                        "END_COLL_NO": "Cancelar",
                        "END_COLL_YES": "Prosseguir",
                        "ALREADY_ENDED": "A colaboração de arquivos já terminou.",
                        "CANNOT_END_COLLABORATION": "Não é possível encerrar a colaboração de arquivos.",
                        "ANNOTATE": "Anotar",
                        "FULLSCREEN": "Tela Cheia",
                        "DOWNLOAD_COLLABORATION": "Download Colaboração",
                        "SNAPSHOT_COLLABORATION": "Instantâneo",
                        "UNDO": "Desfazer",
                        "REDO": "Refazer",
                        "REVERT": "Reverter",
                        "RELOAD": "Recarregar"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "Pin Window?",
                        "MESSAGE": "Pin durante o modo AR+ não é possível. Fechar o AR+ e fixar?",
                        "CANCEL": "Cancelar",
                        "PROCEED": "Continuar"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "Parece que algo correu mal. Estamos a tentar restabelecer a sua chamada."
            },
            "SESSION_RATING": {
                "BAD": "Ruim",
                "POOR": "Inadequada",
                "FAIR": "Média",
                "GOOD": "Boa",
                "EXCELLENT": "Excelente",
                "RATING_MESSAGE" : "Como foi a qualidade da sessão?",
                "REVIEW_MESSAGE" : "Diga-nos por quê (opcional)",
                "SUCCESS_MESSAGE": "Obrigado por avaliar a sessão.",
                "CLOSE": "Fechar",
                "SUBMIT": "Submeter",
                "DISMISS": "Rejeitar"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "Voltar ao Lobby",
                "RUN_PRECALL_TEST": "Execute o teste Precall",
                "WHAT_TEST": {
                    "TITLE": "Nós vamos testar",
                    "CONNECTIVITY": "Conectividade com todos os servidores de mídia.",
                    "STATS": "Colete estatísticas de taxa de bits e perda de pacotes.",
                    "SETUP": "Configuração de hardware & software no ponto final (câmera, microfone, navegador)."
                },
                "BEFORE_START": {
                    "TITLE": "Antes que você comece",
                    "MAKE_SURE": "Certificar-se de que;",
                    "RIGHT_NETWORK": "Você está na rede específica que pretende testar.",
                    "TCP_PORT_OPEN": "Você tem pelo menos a porta TCP 443 aberta.",
                    "RIGHT_HARDWARE": "A câmera e o microfone certos estão selecionados.",
                    "BANDWITH": "A largura de banda é superior a 350kbps de upload e download."
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "Configuração de Hardware/Software",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "Sistema Operacional",
                        "BETTER_ALTERNATIVE_IOS": "Você pode baixar o {{ appName }} Remote App na AppStore para obter uma melhor experiência.",
                        "BETTER_ALTERNATIVE_ANDROID": "Você pode baixar o {{ appName }} Remote App na Google Play Store para obter uma melhor experiência."
                    },
                    "BROWSER": {
                        "MESSAGE": "Navegador",
                        "NOT_SUPPORTED": "Seu navegador não é suportado. Por favor, use o Google Chrome, Mozilla Firefox, Safari ou Microsoft Edge (versão 79 ou mais recente).",
                        "NOT_COMPATIBLE": "Seu navegador não é compatível. Por favor, atualize seu navegador.",
                        "USE_SAFARI": "Seu navegador não é compatível. Por favor, use o aplicativo {{ appName }} Remote ou use o Safari."
                    },
                    "HARDWARE": {
                        "MESSAGE": "Acesso à câmera/microfone",
                        "CANT_ACCESS": "Não podemos acessar sua câmera / microfone."
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "Conexão com nossos servidores",
                    "INTERNET": {
                        "MESSAGE": "Conexão de internet",
                        "OFFLINE": "Sua conexão com a internet parece estar offline."
                    },
                    "SERVERS": {
                        "MESSAGE": "Conexão com nossos servidores",
                        "UNKNOWN_ERROR_TRY": "Ocorreu um erro ao conectar-se aos servidores. Por favor, tente novamente mais tarde.",
                        "UNKNOWN_ERROR": "Ocorreu um erro ao conectar-se aos servidores."
                    }
                },
                "QUALITY": {
                    "TITLE": "Qualidade de Áudio/Vídeo",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "Qualidade de áudio/vídeo",
                        "UNKNOWN_ERROR": "Ocorreu um erro ao testar a qualidade de áudio/vídeo.",
                        "VIDEO": "Vídeo",
                        "VIDEO_QUALITY": "Qualidade de Vídeo: ",
                        "VIDEO_PACKET_LOSS": "Perda de Pacotes: ",
                        "VIDEO_BITRATE": "Vídeo Bitrate: ",
                        "AUDIO": "Áudio",
                        "AUDIO_QUALITY": "Qualidade de Áudio: ",
                        "AUDIO_PACKET_LOSS": "Perda de Pacotes: ",
                        "AUDIO_BITRATE": "Áudio Bitrate: ",
                        "QUALITY_EXCELLENT": "(Excelente)",
                        "QUALITY_GOOD": "(Boa)",
                        "QUALITY_BAD": "(Má)"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "Parar teste?",
                    "MESSAGE": "Isso interromperá o teste Precall.",
                    "NO": "Cancelar",
                    "YES": "Pare"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "Adicionar novo",
                "SECONDARY_PLACEHOLDER": "Insira o endereço de e-mail",
                "INVALID_EMAIL": "Formato de email inválido."
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "Integração já usada",
                    "MISSING_PARAMETERS": "Faltam parâmetros",
                    "CALL_IN_PROGRESS": "A chamada está em andamento",
                    "USER_IN_ANOTHER_ROOM": "Usuário em outra sala"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} Centro de Ajuda",
            "TITLE_WITH_REMOTE": "{{ appName }} Centro de Ajuda Remota",
            "FAILED": "Ocorreu um erro."
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{appName}} Remote Junte-se ao link",
                "SESSION_NOT_FOUND": "A sessão que você solicitou não pode ser encontrada.",
                "SESSION_NOT_AVAILABLE": "Esta sessão não está mais disponível.",
                "CONCURRENT_LIMIT_REACHED": "Limite de usuário simultâneo atingido. Entre em contato com seu administrador.",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "Limite de usuário simultâneo atingido. Entre em contato com seu administrador.",
                "UNKNOWN_ERROR": "Algo deu errado.",
                "ABOUT_TO_JOIN": "Você está prestes a ingressar no ",
                "ENTER_NAME": "Digite Seu Nome",
                "NAME_REQUIRED": "Nome obrigatório",
                "NAME_SHORT": "O nome deve ter pelo menos 2 caracteres",
                "JOIN": "JUNTE-SE",
                "CONTINUE_TO_WEBSITE": "Continuar pelo Navegador"
            },
            "ARCHIVE_LIST": {
                "TITLE": "Registros de videochamadas",
                "LOADING": "Carregando",
                "LOAD_FAILED": "Ocorreu um erro.",
                "CREATED_AT": "Criado em",
                "SIZE": "Tamanho",
                "STATUS": "Status",
                "DOWNLOAD": "Baixar",
                "GENERATING": "Gerando Link",
                "CLICK_TO_DOWNLOAD": "Clique para fazer o download",
                "AVAILABLE": "Disponível",
                "DISCONNECTED": "desconectado",
                "DELETED": "apagada",
                "EXPIRED": "expirado",
                "WAITING": "espera",
                "FAILED": "fracassada"
            },
            "AUTHENTICATE": {
                "MESSAGE": "Um erro ocorreu."
            },
            "AD_LOGIN": {
                "MESSAGE": "Um erro ocorreu."
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "Sua conta não está conectada ao Azure AD.",
                "PERMISSION_DENIED": "Você não tem permissão para ver esta página.",
                "INTERNAL_ERROR": "Um erro ocorreu.",
                "CONTACT_MAIL": "Entre em contato com <strong>{{ contactMail }}</strong>"
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "Mostrar Guia de Uso",
            "NEXT": "Próxima",
            "END": "Fim",
            "MIC_CAMERA": "Abrir/Fechar microfone ou câmera",
            "END_CALL": "Sair da Sessão",
            "RECORD": "Iniciar/Parar a gravação para todas as sessões",
            "SCREEN_SHARING": "Iniciar/Parar o compartilhamento de tela para mostrar o que você faz com outros usuários",
            "REACTION": "Envie uma reação a todos, útil quando a comunicação por voz não é suficiente",
            "OPEN_AR_PLUS": "AR+ aberto",
            "DRAW_ON_SURFACE": "Desenhe em superfícies destacadas com grade azul na transmissão ao vivo com AR+",
            "OPEN_AR": "AR aberto",
            "HOLD_TO_HIGHLIGHT": "Clique e segure em qualquer lugar para destacar uma área específica na transmissão ao vivo com AR",
            "TAKE_SNAPSHOT": "Tire um instantâneo de alta qualidade de outro usuário",
            "NO_CAMERA": "A câmera de outro participante deve estar ligada",
            "WAIT_OR_SKIP": "Aguarde outro usuário ou pule este recurso",
            "COLLABORATE": "Colabore no instantâneo: esboce, coloque diagramas, formas especiais, textos",
            "OPEN_ANNOTATION": "Abrir anotação",
            "SKETCH_ON_COLL": "Esboço no painel de colaboração",
            "END_TUTORIAL": "Você pode acessar este tutorial a qualquer momento a partir daqui",
            "USER_TUTORIAL": "Tutorial do usuário",
            "GUIDE": "Este tutorial do usuário o guiará passo a passo pela plataforma",
            "DONT_SHOW": "Não mostrar novamente",
            "SKIP_TUTORIAL": "Pular tutorial",
            "CANCEL": "Cancelar",
            "SKIP": "Pular",
            "ASK_AGAIN": "Tem certeza de que deseja pular este tutorial?"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "Lamentamos, mas a página que você solicitou não pode ser encontrada.",
            "NO_LONGER_AVAILABLE": "O URL pode estar incorreto ou a página que você está procurando não está mais disponível."
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "Arquivo não encontrado",
            "IF_DOWNLOAD_NOT_STARTED": "Caso o download não tenha iniciado, ",
            "CLICK_HERE": "clique aqui"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Itens por página:",
        "NEXT_PAGE": "Próxima página",
        "PREVIOUS_PAGE": "Página anterior",
        "FIRST_PAGE": "Primeira página",
        "LAST_PAGE": "Última página",
        "RANGE": "{{start}} – {{end}} de {{length}}",
        "RANGE_ZERO": "0 de {{length}}"
    }
}